/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RoleDtoBase
 * auto generated base class for the model RoleDtoModel.
 */
export const RoleDtoModelBase = ModelBase
  .named('RoleDto')
  .props({
    __typename: types.optional(types.literal("RoleDto"), "RoleDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RoleDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromRoleDto() {
  return new RoleDtoModelSelector()
}

export const roleDtoModelPrimitives = selectFromRoleDto().name
